import {
    ARBITER_TAG,
    MENU_TAG,
    LAUNCHER_TAG,
    PROMPT_TAG,
    HEADER_TAG,
    APP_ERROR_TAG,
} from './index'

export const ARBITER_PATH = '/arbiter'
export const MENU_PATH = '/menu'
export const LAUNCHER_PATH = '/launcher'
export const PROMPT_PATH = '/prompt'
export const HEADER_PATH = '/header'
export const APP_ERROR_PATH = '/error'

const zoidTagFromPathname = (pathname) => {
    const paths = {
        [ARBITER_PATH]: ARBITER_TAG,
        [MENU_PATH]: MENU_TAG,
        [LAUNCHER_PATH]: LAUNCHER_TAG,
        [PROMPT_PATH]: PROMPT_TAG,
        [HEADER_PATH]: HEADER_TAG,
        [APP_ERROR_PATH]: APP_ERROR_TAG,
    }

    const tag = paths[pathname]

    if (!tag) {
        throw new Error(`pathname ${pathname} not declared`)
    }

    return tag
}

export default zoidTagFromPathname
